<!--
 * @Author: zl
 * @Date: 2022-09-15 13:48:33
 * @LastEditTime: 2022-09-16 11:59:37
 * @LastEditors: zl
 * @Description: 审计方案
-->
<template>
	<div class='AuditPlan-layout'>
		<el-row>
			<el-col :span="22"
					:offset="1">
				<h2 class="text-center mb30">审 计 方 案</h2>
				<el-descriptions :column="1"
								 size="small"
								 border
								 class="custom-descriptions">
					<el-descriptions-item label="工程项目名称">{{ currentObj.proName }}</el-descriptions-item>
					<el-descriptions-item label="建设单位">{{ form.applyUnitName }}</el-descriptions-item>
					<el-descriptions-item label="审计任务名称">
						{{ form.packName }}{{ form.auditTypeName }}
					</el-descriptions-item>
					<el-descriptions-item label="标段名称">{{ form.packName }}</el-descriptions-item>
					<el-descriptions-item label="审计任务类型">{{ form.auditTypeName }}</el-descriptions-item>
					<el-descriptions-item label="委托单位">{{ form.sponsorUnit }}</el-descriptions-item>
					<el-descriptions-item label="协审单位">{{ form.tenantName }}</el-descriptions-item>
					<el-descriptions-item label="审计方案名称">{{ form.sname }}</el-descriptions-item>
					<el-descriptions-item label="编制人">{{ form.redactUser }}</el-descriptions-item>
					<el-descriptions-item label="审批人">{{ form.auditer }}</el-descriptions-item>
					<el-descriptions-item label="编制日期">
						{{ form.redactDate ? form.redactDate.substr(0, 10) : '' }}
					</el-descriptions-item>
					<el-descriptions-item label="备注"
										  contentClassName="h200">
						{{ form.remark }}
					</el-descriptions-item>
					<el-descriptions-item label="上传附件">
						<myUpload listType="list"
								  ref="planUpload"
								  tableName="audit_scheme"
								  uploadType="2"
								  assortment="test666"
								  width="auto"
								  height="auto"
								  :aid="form.id"
								  mode="view"
								  class="h100 w100"></myUpload>
					</el-descriptions-item>
				</el-descriptions>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import * as API from '@/api/AuditReport/AuditReport'
export default {
	props: {
		currentObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {},
	data() {
		return {
			form: {},
		}
	},
	created() {
		// 获取详情
		this.getDetails()
	},
	mounted() {},
	methods: {
		// 获取详情
		getDetails() {
			API.selectSchemeDetail({
				id: this.currentObj.id,
			}).then((res) => {
				this.form = res.data
			})
		},
	},
	computed: {},
}
</script>

<style lang='less' scoped>
</style>